import angular from 'angular';

angular.module('cxRegistrations').directive('cxPriceOptions', [
  '$filter',
  function($filter) {
    return {
      restrict: 'E',
      template:
        '<div class="input-group-btn" ng-if="visible" uib-dropdown is-open="isOpen">' +
        '<button id="{{id}}-PriceOptionsButton" type="button" class="btn btn-default" title="{{\'Price options\'|translate}}" ng-click="toggleDropdown($event)" ng-class="showWarning() ? \'btn-light-warning\':\'\'">' +
        '<i class="fa  fa-exclamation"></i></button>' +
        '<ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu template-url="assets/templates/registrations/directives/priceOptions.tpl.html"></ul>' +
        '</div>',
      replace: true,
      scope: {
        options: '=',
        data: '=',
        disabled: '=?ngDisabled',
        visible: '=',
        id: '@',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.select = function(item) {
            $scope.data = item;
            $scope.isOpen = false;
          };

          $scope.isVisible = function() {
            if ($scope.disabled || !$scope.options) return false;
            if (!!$scope.data) {
              if ($scope.options) {
                //Show if there is only 1 price and it doesn't match the current price
                if (
                  $scope.options.length === 1 &&
                  ($scope.data.id !== $scope.options[0].id ||
                    $scope.data.amount !== $scope.options[0].amount)
                ) {
                  return true;
                }

                //Show if there are more than 1 price options
                if ($scope.options.length > 1) return true;
              }
            } else {
              //Show if there is no current price and there are price options
              return $scope.options && $scope.options.length > 0;
            }
            return false;
          };

          $scope.toggleDropdown = function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.isOpen = !$scope.isOpen;
          };

          $scope.showWarning = function() {
            if (!$scope.options || !$scope.options.length) return false;
            if (!$scope.data || !$scope.data.id) return true;
            return false;
          };

          $scope.$watch($scope.isVisible, function(newValue) {
            $scope.visible = newValue;
          });
        },
      ],
    };
  },
]);
